define('../common/js/xray',['require','exports','module'],function(require, exports, module) {
    function iReplacer(i) {
        return i.toString().replace(/[^a-zA-Z0-9-]/gi, '-');
    }

    var sendDwh = function(eventCategory, action, label, sendImmediately, dwhData) {
        var name = iReplacer(eventCategory);

        var i = [];

        if (action) {
            i.push(iReplacer(action));
        }

        if (label) {
            i.push(iReplacer(label));
        }

        var params = {
            p: 'cloud-web-analytics'
        };

        if (i.length) {
            params.i = i.join('_');
        }

        if (dwhData) {
            params.dwh = dwhData;
        }

        if (sendImmediately) {
            window.xray.sendImmediately(name, params);
        } else {
            window.xray.send(name, params);
        }
    };

    module.exports = sendDwh;
});

